import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Modal from "app/modules/common/component/Modal";
import * as c from "../constant";

class AddUpdateGovDocs extends PureComponent {
  state = {
    date_validity: "",
    name: "",
    restriction: "",
  };

  handleOnClose = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch({
      type: "MODAL",
      data: {
        isOpen: false,
      },
    });
  };

  handleOnSubmit = (e) => {
    e.preventDefault();
    const { dispatch, form_data } = this.props;
    dispatch({
      type: c.REMOVE_ACCOUNT,
      args: {},
    });
  };

  render() {
    return (
      <div>
        <form onSubmit={this.handleOnSubmit}>
          <Modal.Body>
            <div className="row">
              <div className="col-12 mb-5">
                <div className="text-center">
                  Are you sure you want to remove your account?
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="d-flex flex-row-reverse">
                  <button
                    className="btn btn-danger btn-md"
                    onClick={this.handleOnClose}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary btn-md"
                    onClick={this.printDiv}
                  >
                    Remove Account
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </form>
      </div>
    );
  }
}

const mapPropsToState = (state, props) => {
  const profile = state.auth.get("profile");
  const govdocs = state.govdocs.get("list");
  const education = state.education.get("list");
  const work = state.employment.get("list");
  const training = state.training.get("list");
  const reference = state.characterReference.get("list");

  return {
    profile,
    govdocs,
    education,
    work,
    training,
    reference,
  };
};

export default withRouter(connect(mapPropsToState)(AddUpdateGovDocs));
